import { render, staticRenderFns } from "./CommodityEdit.vue?vue&type=template&id=6c1e95c9&"
import script from "./CommodityEdit.vue?vue&type=script&lang=js&"
export * from "./CommodityEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports